import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const PersonalOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const roles = user?.roles || [];

  if (!roles.includes("personal")) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};

export default PersonalOnlyRoute;
